import { PageStateShare } from '@shared/user-state/ui/PageStateShare';

function stateHasKey<T>(state: Partial<T>, key: keyof T): boolean {
    if (state.hasOwnProperty(key)) {
        return true;
    } else {
        return false;
    }
}

function openStateInOtherMap(state: IPageState) {
    const { url2d, url3d } = PageStateShare.getUrls(state.uuid);
    window.open((window.location.href.includes('main.htm') ? url3d : url2d) + '&confirmStateLoad=false');
}

export const PageStateUtils = {
    stateHasKey,
    openStateInOtherMap,
};
